import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';

import { createSingleInterpolatedTranslationKey } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

type DeleteContinuousMedicationEventInterceptorProps = {
   readonly medicineName: PatientMedicine['medicine']['fullName'];
   readonly children: JSX.Element;
};

const DeleteContinuousMedicationEventInterceptor = (
   props: DeleteContinuousMedicationEventInterceptorProps
): JSX.Element => {
   const content = createSingleInterpolatedTranslationKey(
      translationKeys.medicine.continuouslyUsedMedicine.deleteConfirmationModal.content,
      'medicineName',
      props.medicineName
   );
   return (
      <ShowModalEventInterceptor
         shouldShowModal
         title={translationKeys.medicine.continuouslyUsedMedicine.deleteConfirmationModal.title}
         confirmationButtonLabel={translationKeys.medicine.continuouslyUsedMedicine.deleteConfirmationModal.confirm}
         cancelButtonLabel={translationKeys.medicine.continuouslyUsedMedicine.deleteConfirmationModal.cancel}
         content={content}
         modalWidth={ModalWidth.NORMAL}
         testId={'deleteContinuousMedication'}
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};

export { DeleteContinuousMedicationEventInterceptor };
